import { getInformationWithData, getInformationWithDataV3 } from "../services/CABE"
import { getValueCookie } from "../services/cookieService"
import { getIndexElement } from "./searchInObject"

export function intervalTimeInDays(datestart, datefinish) {
    let day1 = new Date(datestart)
    let day2 = new Date(datefinish)

    let difference = day2 - day1
    let days = difference / (1000 * 3600 * 24)
    days = days.toFixed(0)
    if (days >= 0) {
        if (String(days).length === 1) {
            return "0" + days
        } else {
            return "" + days
        }

    }
    return "00"
}

export function intervalTimeInDays2(datestart, datefinish) {
    let day1 = new Date(datestart)
    let day2 = new Date(datefinish)

    let difference = day2 - day1
    let days = difference / (1000 * 3600 * 24)
    days = days.toFixed(0)
    return days
}

export function Contains(parameter, search) {
    return parameter.toString().toLowerCase().includes(search.toLocaleLowerCase())
}

export function DeleteCharacter(word, character) {
    if (word) {
        let regex = RegExp(character, "g")
        return word.replace(regex, '')
    } else {
        return ""
    }

}

export function ReplaceCharacter(word, character, newCharacter) {
    if (word) {
        let regex = RegExp(character, "g")
        return word.replace(regex, newCharacter)
    } else {
        return ""
    }

}

export function DeleteStrangeCharacter(word) {
    return word.replace(/[^\w\s\-\\&\\//]/gi, '')
}

export function DeleteCharactersNotAccepted(word) {
    return word.replace(/[^a-zA-Z0-9]/g, "")
}

export function NumberFormat(num) {
    // 2026-08-25 fix — only `null` was treated as "empty"; a genuinely
    // `undefined` value (a field missing from an API response, a totals
    // object not loaded yet, etc.) fell straight through to num.toString()
    // below and threw "Cannot read properties of undefined (reading
    // 'toString')". Intermittent because it only happens when the specific
    // field a given caller passes happens to be undefined at that moment —
    // NumberFormat() is called from 100+ places across the app with raw API
    // fields, so which one trips it depends on the data, not the code path.
    if(num === null || num === undefined){
        num = 0
    }
    const regex = /(\d)(?=(\d{3})+(?!\d))/g;
    const com = '$1,';
    let tempo = num.toString().split('.');
    tempo[0] = tempo[0].replace(regex, com);
    return tempo[1] ? tempo.join('.') : tempo[0];
}

export function MonthInLetters(monthNum) {
    
    switch (Number(monthNum)) {
        case 1:
            return "January"
        case 2:
            return "February"
        case 3:
            return "March"
        case 4:
            return "April"
        case 5:
            return "May"
        case 6:
            return "June"
        case 7:
            return "July"
        case 8:
            return "August"
        case 9:
            return "September"
        case 10:
            return "October"
        case 11:
            return "November"
        case 12:
            return "December"
        case 0:
                return "December"
        default:
            return ""

    }
}

export function OrderArray(arreglo, llave, bandera) {

    const l = arreglo.length;
    if (bandera) {
        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {
                if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                    [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                }
            }
        }
    } else {
        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {
                if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                    [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                }
            }
        }
    }
    return arreglo;
}

export async function getIMGByItemCode(itemCode) {
    const data = {
        idCompany: Number(getValueCookie('CompanyId')),
        ItemCode: itemCode
    }
    const resultImg = await getInformationWithData('/Items/get/Img', data)
    let itemURLImage = ''
    if (resultImg.status.code === 1) {
        if (resultImg.data.itemURLImage) {
            if (resultImg.data.itemURLImage !== '') {
                const date = new Date().getTime()
                itemURLImage = `${resultImg.data.itemURLImage}?${date}`
            } else {
                itemURLImage = ''
            }
        } else {
            itemURLImage = ''
        }
    }

    return itemURLImage
}

export async function getIMGByItemCodeV2(itemCode) {
    const data = {
        idCompany: Number(getValueCookie('CompanyId')),
        ItemCode: itemCode
    }
    const resultImg = await getInformationWithData('/Items/get/Img', data)
    let itemURLImage = ''
    const resImg = resultImg.data[0];
    if (resultImg.status.code === 1 && resImg.itemURLImage && resImg.itemURLImage !== '') {
        itemURLImage = resImg.itemURLImage;
    }
    return itemURLImage
}

export function material_cold_rgba(index = 0) {
  const colors = [
    'rgba(211, 47, 47, 1)',    // Red 600 - Warm, high contrast
    'rgba(123, 31, 162, 1)',   // Purple 700 - Cool, distinct
    'rgba(25, 118, 210, 1)',   // Blue 700 - Primary blue
    'rgba(0, 137, 123, 1)',    // Teal 600 - Blue-green
    'rgba(67, 160, 71, 1)',    // Green 600 - Natural green
    'rgba(251, 192, 45, 1)',   // Amber 600 - Warm yellow
    'rgba(245, 124, 0, 1)',    // Orange 700 - Vibrant orange
    'rgba(57, 73, 171, 1)',    // Indigo 600 - Deep blue-purple
    'rgba(216, 27, 96, 1)',    // Pink 700 - Magenta
    'rgba(94, 53, 177, 1)',    // Deep Purple 600 - Rich purple
  ];
  
  return colors[index % colors.length];
}

export function random_rgba() {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ', 1)';
}

export function AleatoryNumber(min, max) {
    return String(Math.floor((Math.random() * ((max - min) + 1)) + min))
}

export function getPriceMargin(price, cost, priceLevel) {
    let priceMargin = "0"
    if (price && cost) {
        if (price > 0) {

            if (getValueCookie('CompanyId') === '6') {
                cost = cost / 0.95
            }

            priceMargin = (((price - cost) / price) * 100).toFixed(0)
        }
    }
    return String(AleatoryNumber(10000563, 20000013)) + "00" + priceMargin + "00"
}

export function getPriceMarginV2(products) {
    let totalMargin = 0;
    products.map((product) => {
        let priceMargin = 0
        if (product.UnitPrice && product.unitCost && product.quantityShipped > 0) {
            // if (product.UnitPrice > 0) {
                const numericUnitPrice = Number(product.UnitPrice);
                const numericUnitCost = Number(product.unitCost);
                priceMargin = (((numericUnitPrice - numericUnitCost) / numericUnitPrice) * 100).toFixed(0);
                // console.log("priceMargin", priceMargin);
            // }
        }
        totalMargin += Number(priceMargin);
        // console.log("totalMargin", totalMargin);
    })
    const finalMargin = (totalMargin / products.length).toFixed(0)
    // console.log("finalMargin", finalMargin);

    return String(AleatoryNumber(10000563, 20000013)) + "00" + finalMargin + "00"
}

/**
 * 2026-08-25 — InvoiceV3-only trucking-number margin. Split off from
 * getPriceMarginV2() (still used as-is by Invoice.js/v1) instead of changing
 * it in place, so this fix doesn't change behavior for the older Invoice
 * flow. Two differences from getPriceMarginV2():
 *
 *  1. The average only counts lines with quantityShipped > 0. A removed line
 *     (InvoiceV3.js's removeProduct() zeroes quantityShipped/Visible but
 *     leaves the line in the Products array) or a line backordered to 0 is
 *     "as if it wasn't sold" and shouldn't dilute the average — it's
 *     excluded from both the sum and the divisor, not just zeroed.
 *
 *  2. Cost prefers costAtSale over unitCost. unitCost's origin is
 *     inconsistent within the same invoice: raw MAS90 cost for lines carried
 *     over from an existing Sales Order (SalesOrderPicking.js's
 *     itemJson.unitCost), vs. the already-correct v3 pricing cost for lines
 *     added via the in-invoice catalog (buildInvoiceCartLine.js). costAtSale
 *     is always sourced from /v3/pricing/map (InvoiceV3.js's
 *     classifyProducts()/buildInvoiceCartLine.js), the one cost every line
 *     ends up with from the same place regardless of how it entered the
 *     invoice — falls back to unitCost only if costAtSale hasn't loaded yet
 *     for that line.
 */
/**
 * 2026-08-27 — reworked to a revenue-weighted blended margin (client's ask),
 * replacing the old "average of each line's own margin %" approach. Formula:
 *   (totalInvoicePrice - totalProductCost) / totalInvoicePrice
 * i.e. total profit over total revenue — a line selling 500 units now
 * properly outweighs a line selling 1, instead of each line counting equally
 * regardless of size.
 *
 * Format changed too: the margin is taken to 2 decimals (##.##) and dropped
 * into the trucking number WITHOUT the decimal point (4 digits), and the
 * random prefix grew from 8 to 9 digits — client's exact spec:
 *   #########00####   (9 random digits + "00" + margin, no dot, 4 digits)
 *
 * Only shipped lines count (quantityShipped > 0) — same reasoning as before:
 * a removed/backordered-to-0 line is "as if it wasn't sold" and shouldn't
 * affect the invoice's blended margin.
 *
 * Edge case, flagged rather than silently "handled": the ##.## slot only
 * has room for 00.00–99.99. A margin at/above 100% (selling above double
 * cost isn't unusual, but 100%+ margin — cost near/at zero — is the actual
 * trigger) or a net loss (negative margin, cost > revenue overall) would
 * either overflow the 4-digit slot or need a sign the format has no room
 * for. Clamped to that range for now so the trucking number always comes
 * out a well-formed 15-digit string instead of a malformed one — revisit if
 * a real invoice actually hits either edge.
 */
export function getInvoiceV3PriceMargin(products) {
    const shippedProducts = products.filter((product) => Number(product.quantityShipped) > 0)

    let totalPrice = 0
    let totalCost = 0
    shippedProducts.forEach((product) => {
        const quantity = Number(product.quantityShipped)
        const price = Number(product.UnitPrice) || 0
        const rawCost = (product.costAtSale !== undefined && product.costAtSale !== null)
            ? product.costAtSale
            : product.unitCost
        const cost = Number(rawCost) || 0
        totalPrice += price * quantity
        totalCost += cost * quantity
    })

    let marginPercent = totalPrice > 0 ? ((totalPrice - totalCost) / totalPrice) * 100 : 0
    marginPercent = Math.min(Math.max(marginPercent, 0), 99.99) // see edge-case note above

    const marginDigits = marginPercent.toFixed(2).replace('.', '').padStart(4, '0')

    return String(AleatoryNumber(100000000, 999999999)) + "00" + marginDigits
}

export function getPurePriceMargin(price, cost) {
    let priceMargin = "0"
    if (price && cost) {
        if (price > 0) {

            if (getValueCookie('CompanyId') === '6') {
                cost = cost / 0.95
            }

            priceMargin = (((price - cost) / price) * 100).toFixed(0)
        }
    }
    return Number(priceMargin)
}

export function decimalToHour(decimal) {
    const horas = Math.floor(decimal);
    const minutos = Math.round((decimal % 1) * 60);
    let hour = (horas <= 9) ? "0" + horas : "" + horas
    let min = (minutos <= 9) ? "0" + minutos : "" + minutos

    const fecha = new Date();
    fecha.setHours(horas, minutos);
    return hour + ":" + min;
}

export function Delay(n) {
    return new Promise(function (resolve) {
        setTimeout(resolve, n * 1000);
    });
}

export async function ItemDesc(array, keyToChange, keyItem, prodLine) {
    if (array.length > 0) {
        const data = {
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
        }
        const invent = await getInformationWithData('/Items/get', data)
        if (getValueCookie('CompanyId') === '6') {
            data.idcompany = '3'
            data.company = 'Mayaland Atlanta'
            const inventM = await getInformationWithData('/Items/get', data)
            invent.status.code = inventM.status.code
            for (const item of inventM.data) {
                const index = getIndexElement(invent.data, 'itemCode', item.itemCode)
                if (index !== -1) {
                    await invent.data.splice(index, 1)
                }
            }
            invent.data = invent.data.concat(inventM.data)

        }


        if (invent.status.code === 1) {
            let desc = ''
            for (const item of array) {
                const index = getIndexElement(invent.data, 'itemCode', item[keyItem])

                if (index !== -1) {
                    desc = (!(invent.data[index].completeDesc) || invent.data[index].completeDesc === "null") ? invent.data[index].abbreviatedDesc : invent.data[index].completeDesc
                    item.LastDueDate = invent.data[index].LastDueDate
                    if (desc) {
                        item[keyToChange] = desc
                        if (prodLine) {
                            item.OnHand = invent.data[index].quantity ? invent.data[index].quantity : 0
                            item.ProductLine = invent.data[index].ProductLineDesc
                        }
                    }
                } else {
                    if (prodLine) {
                        item.OnHand = 0
                    }
                }
            }

        }
    }

    return array

}

// Retrieve from rds
export async function ItemDescV2(array, keyToChange, keyItem, prodLine) {
    if (array.length > 0) {
        const data = {
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
        }
        const invent = await getInformationWithData('/v2/items/get', data)
        if (getValueCookie('CompanyId') === '6') {
            data.idcompany = '3'
            data.company = 'Mayaland Atlanta'
            const inventM = await getInformationWithData('/Items/get', data)
            invent.status.code = inventM.status.code
            for (const item of inventM.data) {
                const index = getIndexElement(invent.data, 'itemCode', item.itemCode)
                if (index !== -1) {
                    await invent.data.splice(index, 1)
                }
            }
            invent.data = invent.data.concat(inventM.data)

        }


        if (invent.status.code === 1) {
            let desc = ''
            for (const item of array) {
                const index = getIndexElement(invent.data, 'itemCode', item[keyItem])

                if (index !== -1) {
                    desc = (!(invent.data[index].completeDesc) || invent.data[index].completeDesc === "null") ? invent.data[index].abbreviatedDesc : invent.data[index].completeDesc
                    item.LastDueDate = invent.data[index].LastDueDate
                    if (desc) {
                        item[keyToChange] = desc
                        if (prodLine) {
                            item.OnHand = invent.data[index].quantity ? invent.data[index].quantity : 0
                            item.ProductLine = invent.data[index].ProductLineDesc
                        }
                    }
                } else {
                    if (prodLine) {
                        item.OnHand = 0
                    }
                }
            }
        }
    }

    return array

}

// RDS-only replacement for ItemDescV2 above (2026-09-09, client-reported
// crash on /reports/sales for Altitude): ItemDescV2 fetches the ENTIRE
// product catalog over a live MAS90/Altitude WebSocket just to read off a
// handful of descriptions, and crashes outright when that worker isn't
// connected — see api-portal-manager/src/v3_controllers/salesOrderCatalog.ts's
// getItemDescriptions for the full writeup. Only Sales.js used ItemDescV2
// (confirmed 2026-09-09), and only for description/keyToChange — never for
// LastDueDate/OnHand/ProductLine (the `prodLine` branch), so this only
// covers that subset; ItemDescV2 itself is left untouched in case something
// else ever needs the fuller behavior.
export async function ItemDescV3(array, keyToChange, keyItem) {
    if (array.length === 0) return array
    const itemCodes = [...new Set(array.map((item) => item[keyItem]).filter(Boolean))]
    if (itemCodes.length === 0) return array

    const resp = await getInformationWithDataV3('/v3/salesorder/item-descriptions', {
        idCompany: getValueCookie('CompanyId'),
        itemCodes,
    })

    if (resp && resp.status && resp.status.code === 1 && Array.isArray(resp.data)) {
        for (const item of array) {
            const match = resp.data.find((d) => d.itemCode === item[keyItem])
            if (match && match.description) {
                item[keyToChange] = match.description
            }
        }
    }

    return array
}

export function MobileDisp() {
    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Opera Mini/i)) {
        return false
    }
    return true
}

export function validateNumbersForQuantitys(num) {

    var regex = /^(\d+|(\d*\.)?\d*\.5)$/;
    return regex.test(num);
}
export function DecimalPart(numero) {
    var parteDecimal = numero % 1;
    return parteDecimal;
}

export function generateRandomPassword() {
    const length = 7;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    let password = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        password += charset[randomIndex];
    }

    return password;
};

export function OrderArrayASCDESC(arr, key, orden) {
    return arr.sort(function (a, b) {
        if (a[key] < b[key]) {
            return orden === 'asc' ? -1 : 1;
        }
        if (a[key] > b[key]) {
            return orden === 'asc' ? 1 : -1;
        }
        return 0;
    });
}

export function NameSalesPerson(SalesPerson) {
    switch (SalesPerson) {
        case "AM":
            return "Andrea Martínez";
        case "RR":
            return "Rafael Rivera";
        case "AS":
            return "Luz Hernández";
        case 'KL2':
            return 'Katherine Lopez';
        case "0010":
            return "Corporativo";
        case "0000":
            return "Altitude";
        case "JDL":
            return "Juan David";
        case "FS":
            return "Francis Santana";
        case "BP":
            return "Beatriz Pacheco";
        case "JR":
            return "Jeymar Rios";
        case "TOT":
            return "Totals";
        case "JC":
            return "Josue Contreras";
        case "WW":
            if(getValueCookie('CompanyId') === '3') {
                return "Altitude";
            }
            
            return "Portal Admin";
        default:
            return SalesPerson;
    }
}

export function filterAndSortData(arr, num) {

    const objetosOrdenados = arr.filter(objeto => {
        return objeto.NumberofDays >= num || objeto.NumberofDays === "Never";
    }).sort((a, b) => {
        if (a.NumberofDays === "Never") return 1; // "Never" se coloca al final
        if (b.NumberofDays === "Never") return -1; // "Never" se coloca al final
        return a.NumberofDays - b.NumberofDays;
    });
    /* this.setState({ Data: objetosOrdenados })
    console.log("obj;", this.state.Data)
    console.log(objetosOrdenados); */
    return objetosOrdenados;
}
export default { intervalTimeInDays, Contains, DeleteCharacter, NumberFormat, MonthInLetters, OrderArray, getIMGByItemCode, random_rgba, AleatoryNumber, getPriceMargin, getPurePriceMargin, MobileDisp, filterAndSortData }